"use client";

import { useTranslations } from "next-intl";

export interface PrototypingToProductionProps {
	/** 翻译命名空间，需包含 titleLine1、titleLine2、card1Number～card3Number、card1Title～card3Title、card1Desc～card3Desc */
	translationNamespace?: string;
}

/**
 * 「We Support From Prototyping to Production」三卡片区块：标题 + 01/02/03 卡片（前两卡灰底，第三卡浅黄底）
 */
export default function PrototypingToProduction({
	translationNamespace = "rapidPrototypingSupport",
}: PrototypingToProductionProps) {
	const t = useTranslations(translationNamespace);

	const cards = [
		{ numberKey: "card1Number", titleKey: "card1Title", descKey: "card1Desc", highlight: false },
		{ numberKey: "card2Number", titleKey: "card2Title", descKey: "card2Desc", highlight: false },
		{ numberKey: "card3Number", titleKey: "card3Title", descKey: "card3Desc", highlight: true },
	] as const;

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				{/* 居中双行标题 */}
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					<span className="block">{t("titleLine1")}</span>
					<span className="block">{t("titleLine2")}</span>
				</h2>

				{/* 三张卡片 */}
				<div className="grid gap-6 md:grid-cols-3">
					{cards.map((card) => (
						<div
							key={card.titleKey}
							className={`rounded-lg p-6 md:p-8 ${card.highlight ? "bg-[#FAFFDF]" : "bg-gray-100"}`}
						>
							<p className="mb-3 text-sm font-medium text-gray-400">{t(card.numberKey)}</p>
							<h3 className="mb-4 text-lg font-bold text-black sm:text-xl md:text-2xl">{t(card.titleKey)}</h3>
							<p className="text-sm leading-relaxed text-black md:text-base">{t(card.descKey)}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
